import * as types from './mutation-types'

export default {
  [types.SET_INITIAL_DATA] (state, data) {
    if (data.accountsCount){
      state.accountCount = data.accountsCount
    }
    if (data.invoicesCount){
      state.invoiceCount = data.invoicesCount
    }
    if (data.purchaseOrdersCount){
      state.purchaseOrderCounts = data.purchaseOrdersCount
    }
  },

  [types.GET_INITIAL_DATA] (state, data) {
    state.isDataLoaded = data
  },
  
  
}
